import RemoveIcon from 'components/ReusableComponents/Icons/Remove'

import styles from './OptOutButton.module.scss'

const OptOutButton = ({ onClick }) => (
  <button onClick={onClick} className={styles.button}>
    <RemoveIcon />
    <div className={styles.buttonTexts}>
      <div className={styles.buttonTitle}>Opt-out</div>
      <div className={styles.buttonDescription}>Add to do not call</div>
    </div>
  </button>
)

export default OptOutButton
